import { AfterViewInit, Component, ElementRef } from "@angular/core";
import { NavigationHierarchyService } from "@common/route/navigation-hierarchy.service";
import { INavigationNode } from "@common/route/navigation-node.interface";
import { CommonSidebarConstants } from "@common/shell/common-sidebar/common-sidebar.constants";
import { ShellUiService } from "@common/shell/shell-ui.service";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { PersonNavigationService } from "app/platform/navigation/person-navigation.service";
import { combineLatest, debounceTime, filter, Observable, take } from "rxjs";

@Component({
    selector: "adapt-personal-tab-content",
    templateUrl: "./personal-tab-content.component.html",
    standalone: false,
})
export class PersonalTabContentComponent extends BaseComponent implements AfterViewInit {
    public personalHierarchy$: Observable<INavigationNode | undefined>;

    public constructor(
        navHierarchyFactory: NavigationHierarchyService,
        private shellUiService: ShellUiService,
        elementRef: ElementRef,
    ) {
        super(elementRef);
        this.personalHierarchy$ = navHierarchyFactory.hierarchyChanged(PersonNavigationService.HierarchyId);
    }

    public ngAfterViewInit() {
        // this is to workaround the issue when refreshing on a personal page where personal tab is not shown
        // e.g. On jesse's profile page as stakeholder manager where personal tab won't be shown - currently in prod, it shows a blank personal tab content and no tab selected
        setTimeout(async () => {
            const isPersonalSidebarTabShown = await this.shellUiService.tabIsDisplayed(CommonSidebarConstants.PersonSidebarId);
            const activeTab = await this.shellUiService.getCurrentActiveTab();
            combineLatest([isPersonalSidebarTabShown, activeTab.pipe(filter((tab) => !!tab))]).pipe(
                debounceTime(300), // to wait for the sidebar to update the active tab after the refresh
                take(1),
                this.takeUntilDestroyed(),
            ).subscribe(([isPersonalSidebarVisible, currentActiveTab]) => {
                if (!isPersonalSidebarVisible && currentActiveTab?.id === CommonSidebarConstants.PersonSidebarId) {
                    // sometimes personal sidebar open even if it is not supposed to be visible (especially using stakeholder manager)
                    // - in this case, we need to redirect to org tab as personal tab won't be shown and it would be left with blank content
                    this.shellUiService.focusTab(CommonSidebarConstants.OrganisationSidebarId);
                }
            });
        });
    }
}
